import React, { useEffect } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { userControlModel } from '../userControlModel'
import { IUserControlDetail } from '../userControlService'
import { useDictModel } from '@/views/base/dict/dictModel'
import moment from 'moment'
import { momentFormat } from '@/utils/utils'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg,loadData, setSelectedRowKeys,setUserDetailVisible } = userControlModel()
    const { getTreeNodeName } = useDictModel(() => [])

    useEffect(() => {
        loadData()
    }, [])
    const detialEdit = (value) => {
        setUserDetailVisible(true);
        setSelectedRowKeys(value)
    }
    const columns: ColumnsType<IUserControlDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '用户编码',
            width: 120,
            dataIndex: 'code',
            render: (t, r) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={()=>detialEdit(r)} > {t} </span>)
        },
        {
            title: '用户名称',
            width: 160,
            dataIndex: 'name',
        },
        {
            title: '用户类型',
            width: 160,
            dataIndex: 'userTypeName',
        },
        {
            title: '所属部门',
            width: 160,
            dataIndex: 'orgName',
        },
        {
            title: '联系电话',
            width: 160,
            dataIndex: 'phoneNumber',
        },
        {
            title: '创建人',
            width: 100,
            dataIndex: 'createUser',
        },
        {
            title: '创建时间',
            width: 200,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`
        },
        {
            title: '用户状态',
            width: 200,
            dataIndex: 'status',
            render: (text) => <span >{text==1?'关闭':'开启'}</span>
        },
    ]

    //点击行选高亮
    const onRow = (record: IUserControlDetail) => {
        // let findObj = selectedRowKeys.find((item) => item.id === record.id)
        // if (findObj) {
        //     let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
        //     setSelectedRowKeys(newSelectedRowKeys)
        // } else {
        //     setSelectedRowKeys((origin) => [...origin, record])
        // }
        setSelectedRowKeys(record)
    }

    return (
        <Table
            rowKey={(record) => (record.id as string)}
            // rowSelection={{
            //     //全部选中时 (存row[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
            //             : setSelectedRowKeys((origin) => {
            //                 let changeRowId = changeRows.map(item => item.id);
            //                 return origin.filter(item => changeRowId.indexOf(item.id) < 0)
            //             });
            //     },
            //     onSelect: (record, selected, selectedRows) => onRow(record),
            //     selectedRowKeys: selectedRowKeys.map(item => item.id)
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomCenter'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record),
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 400px)" }}
        />
    )
}
